// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"P6-z","colorTextValue":"Q6-z","swatches":"R6-z","collapseLink":"S6-z","isCollapsed":"T6-z","dropdown":"U6-z","disabled":"V6-z"};